export default {
  name: 'form-steps',
  props: ['actualStep', 'maxSteps', 'widgetStyle', 'actualHotlineStatus'],
  computed: {
    style() {
      return {
        color: this.widgetStyle.main_color,
      };
    },
    __hotlineStatusMap() {
      return {
        welcome_afterhours: { step: 1, max: 2 },
        leave_message: { step: 2, max: 2 },
        choose_date_and_time: { step: 2, max: 2 },
      };
    },
    mapHotlineStatusToSteps() {
      return this.__hotlineStatusMap[this.actualHotlineStatus];
    },
  },
};
